import styled from "styled-components";

export const DoctorsContainer = styled.div`
  width: min(92%, 1280px);
  margin: 100px auto 0;

  @media (max-width: 600px) {
    margin-top: 70px;
  }
`;

export const DoctorBlock = styled.div`
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 48px;
  align-items: center;
  background: var(--color-bg-soft);
  padding: 40px;
  border-radius: var(--radius-xl);
  border: 1px solid var(--color-border);

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 28px;
    text-align: center;
  }

  @media (max-width: 600px) {
    padding: 22px;
  }
`;

export const DoctorPhotos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;

export const DoctorImage = styled.img`
  width: 100%;
  max-width: 320px;
  aspect-ratio: 8 / 9;
  object-fit: cover;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
`;

export const DoctorTable = styled.div`
  margin-top: 16px;
`;

export const DoctorText = styled.div``;

export const MainText = styled.p`
  font-size: 17px;
  line-height: 1.55;
  font-weight: 500;
  color: var(--color-text);
  margin: 6px 0;

  ${DoctorPhotos} & {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    color: var(--color-primary);
    margin-top: 4px;
  }
`;

export const HeadText = styled.p`
  text-align: center;
  line-height: 1.2;
  font-size: clamp(26px, 3.4vw, 36px);
  font-weight: 800;
  color: var(--color-primary);
  letter-spacing: -0.5px;
  margin: 0 0 30px;
`;

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: left;
  margin-top: 22px;

  @media (max-width: 900px) {
    justify-content: center;
  }

  a {
    text-decoration: none;
  }
`;

export const ButtonContainer = styled.div`
  cursor: pointer;
  background: var(--color-primary);
  padding: 14px 32px;
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-md);
  font-weight: 700;
  letter-spacing: 0.4px;
  box-shadow: 0 8px 18px rgba(91, 139, 15, 0.28);
  transition: var(--transition);

  &:hover {
    background: var(--color-primary-dark);
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(91, 139, 15, 0.36);
  }
`;
